import { Modal, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import {
  getExplorerLimitReachedMessage,
  getExplorerWeeklyResetLabel,
} from "../../utils/explorerConnectionLimitCopy";

type Props = {
  show: boolean;
  onHide: () => void;
  weekResetsUtc?: string;
  used?: number;
  limit?: number;
};

/** Hard paywall when an Explorer exhausts the weekly connection action budget. */
export function ExplorerConnectionLimitModal({
  show,
  onHide,
  weekResetsUtc,
  used = 1,
  limit = 1,
}: Props) {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const locale = i18n.resolvedLanguage ?? i18n.language;

  const message = getExplorerLimitReachedMessage(t, {
    locale,
    weekResetsUtc,
    used,
    limit,
  });
  const resetLabel = getExplorerWeeklyResetLabel(t, locale, weekResetsUtc);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      aria-labelledby="explorer-connection-limit-title"
      className="explorer-limit-paywall-modal"
      backdropClassName="explorer-limit-paywall-backdrop"
    >
      <Modal.Header closeButton>
        <Modal.Title id="explorer-connection-limit-title">
          {t("connections.explorerWeeklyLimitTitle")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p className="mb-3 fw-medium">{message}</p>
        <p className="mb-0 small text-secondary">{resetLabel}</p>
      </Modal.Body>
      <Modal.Footer className="flex-column flex-sm-row gap-2 border-0 pt-0">
        <Button variant="outline-secondary" className="w-100 w-sm-auto" onClick={onHide}>
          {t("connections.explorerWeeklyLimitDismiss")}
        </Button>
        <Button
          variant="primary"
          className="w-100 w-sm-auto"
          onClick={() => {
            onHide();
            navigate("/register-user");
          }}
        >
          {t("connections.explorerWeeklyLimitUpgrade")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
